module.exports = __webpack_public_path__ + "static/TT-Plans-Stacking_Plan-f82a7c7b49b4f66b562f0c2cf030d53b.pdf";